import { ts_json, timeSeriesGUIElements } from '@/services/importingJsons.js'

const timeSeriesReport = {
  namespaced: true,
  state: {
    loading: false,
    error: false,
    variables: {
      headings: [],
      options: []
    },
    reportTypes: {
      heading: '',
      options: []
    },
    reportTypesData: {},
    jsonInBackend: {
      data: null
    },
    selected: {
      selectAllSignals: false,
      ecus: [],
      uniqueNameIdentifiers: [],
      variablesSignal: [],
      unitSignal: [],
      rtbdSignal: [],
      customReportLink: null,
      reportType: null,
      variables: [],
      filteringMethod: 'single-period',
      dateAndTime: {
        raw: {
          dateFrom: '',
          dateTo: '',
          timeFrom: {
            HH: '00',
            mm: '00',
            ss: '00'
          },
          timeTo: {
            HH: '00',
            mm: '00',
            ss: '00'
          }
        },
        formatted: {
          dateFrom: '',
          dateTo: '',
          timeFrom: {
            HH: '00',
            mm: '00',
            ss: '00'
          },
          timeTo: {
            HH: '00',
            mm: '00',
            ss: '00'
          }
        }
      },
      multiplePeriods: {
        daysBackFilter: '',
        timeFrom: {
          HH: '00',
          mm: '00',
          ss: '00'
        },
        timeTo: {
          HH: '23',
          mm: '59',
          ss: '59'
        }  
      }
    }
  },
  mutations: {
    setState (state, payload) {
      state[payload.prop] = payload.value
    },
    selected (state, payload) {
      state.selected[payload.prop] = payload.value
    },
    jsonInBackend (state, payload) {
      state.jsonInBackend[payload.prop] = payload.value
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    setDefaultState (state) {
      state.loading = false
      state.error = false
      state.variables = {
        headings: [],
        options: []
      }
      state.reportTypes = {
        heading: '',
        options: []
      }
      state.reportTypesData = {}
      state.selected = {
        variables: [],
        reportType: null
      }
    },
    setDefaultSelectionState (state) {
      state.selected = {
        selectAllSignals: false,
        ecus: [],
        uniqueNameIdentifiers: [],
        variablesSignal: [],
        unitSignal: [],
        rtbdSignal: [],
        customReportLink: null,
        variables: [],
        reportType: null,
        filteringMethod: 'single-period',
        dateAndTime: {
          raw: {
            dateFilter: '',
            dateFrom: '',
            dateTo: '',
            timeFrom: {
              HH: '00',
              mm: '00',
              ss: '00'
            },
            timeTo: {
              HH: '00',
              mm: '00',
              ss: '00'
            }
          },
          formatted: {
            dateFrom: '',
            dateTo: '',
            timeFrom: {
              HH: '00',
              mm: '00',
              ss: '00'
            },
            timeTo: {
              HH: '00',
              mm: '00',
              ss: '00'
            }
          }
        },
        multiplePeriods: {
          daysBackFilter: '',
          timeFrom: {
            HH: '00',
            mm: '00',
            ss: '00'
          },
          timeTo: {
            HH: '23',
            mm: '59',
            ss: '59'
          }  
        }
      }
    }
  },
  getters: {
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    loadStateFromFile ({ commit, dispatch }, data) {
      dispatch('reset')
      commit('overwriteSelected', data)
    },
    loadData ({ commit }) {
      commit('setState', { prop: 'loading', value: true })
      commit('setState', { prop: 'error', value: false })

      const params = {
        resultFile: 'GetTSGEl',
        _program: 'GetTimeSeriesGUIElements'
      }
      ts_json().then(response => {
        commit('setState', {
          prop: 'reportTypes',
          value: response.reportTypes
        })
        commit('setState', {
          prop: 'reportTypesData',
          value: response.reportTypesData
        })
      }).catch(error => {
        console.error('GetTimeSeriesGUIElements Error: ', error)
        commit('setState', { prop: 'error', value: true })
      }).finally(() => {
        commit('setState', { prop: 'loading', value: false })
      })
      timeSeriesGUIElements().then(response => {
        commit('setState', {
          prop: 'variables',
          value: response.variables
        })
      }).catch(error => {
        console.error('GetTimeSeriesGUIElements Error: ', error)
        commit('setState', { prop: 'error', value: true })
      }).finally(() => {
        commit('setState', { prop: 'loading', value: false })
      })
    },
    updateSelection ({ commit }, payload) {
      commit('selected', payload)
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default timeSeriesReport
